export const resetPasswordStaticData = {
  confirmPasswordText: 'Confirm Password',
  enterNewPasswordText: 'Enter your new password',
  passwordInputText: 'Password',
  passwordInputPlaceholder: 'Enter new password',
  confirmPasswordInputText: 'Confirm Password',
  confirmPasswordInputPlaceholder: 'Re-enter new password',
  confirmPasswordButtonText: 'Confirm Password',
  congratulationText: 'Password changed successfully',
  congratulationMessageText:
    'Your password has been reset successfully. Please log in again with your new password.',
  signInButton: 'Back to Login',
  privacyPolicyText: 'Privacy Policy',
  termConditionText: 'Terms & Condition',
  loginImageText: 'Illustration In Progress',
  passwordLength: 'Password must be at least 8 characters long',
  passwordUppercase: 'Password must include at least one uppercase letter',
  passwordLowercase: 'Password must include at least one lowercase letter',
  passwordSpecial: 'Password must include at least one special character',
  passwordDigit: 'Password must include at least one digit',
  passwordsNotMatch: 'Passwords do not match',
  passwordRequirementsTitle: 'Password must contain:',
  ruleMinLength: 'At least 8 characters',
  ruleUppercase: 'At least one uppercase letter (A-Z)',
  ruleLowercase: 'At least one lowercase letter (a-z)',
  ruleSpecial: 'At least one special character',
};

export const resetPasswordHindiData = {
  confirmPasswordText: 'पासवर्ड की पुष्टि करें',
  enterNewPasswordText: 'अपना नया पासवर्ड दर्ज करें',
  passwordInputText: 'पासवर्ड',
  passwordInputPlaceholder: 'नया पासवर्ड दर्ज करें',
  confirmPasswordInputText: 'पासवर्ड की पुष्टि करें',
  confirmPasswordInputPlaceholder: 'नया पासवर्ड पुनः दर्ज करें',
  confirmPasswordButtonText: 'पासवर्ड की पुष्टि करें',
  congratulationText: 'पासवर्ड सफलतापूर्वक बदल दिया गया',
  congratulationMessageText:
    'आपका पासवर्ड सफलतापूर्वक रीसेट कर दिया गया है। कृपया अपने नए पासवर्ड से दोबारा लॉग इन करें।',
  signInButton: 'लॉगिन पर वापस जाएँ',
  privacyPolicyText: 'गोपनीयता नीति',
  termConditionText: 'नियम और शर्तें',
  loginImageText: 'चित्रण प्रगति पर है',
  passwordLength: 'पासवर्ड कम से कम 8 अक्षर लंबा होना चाहिए',
  passwordUppercase: 'पासवर्ड में कम से कम एक अपरकेस अक्षर शामिल होना चाहिए',
  passwordLowercase: 'पासवर्ड में कम से कम एक लोअरकेस अक्षर शामिल होना चाहिए',
  passwordSpecial: 'पासवर्ड में कम से कम एक विशेष वर्ण शामिल होना चाहिए',
  passwordDigit: 'पासवर्ड में कम से कम एक अंक शामिल होना चाहिए',
  passwordsNotMatch: 'पासवर्ड मेल नहीं खाते',
  passwordRequirementsTitle: 'पासवर्ड में होना चाहिए:',
  ruleMinLength: 'कम से कम 8 अक्षर',
  ruleUppercase: 'कम से कम एक अपरकेस अक्षर (A-Z)',
  ruleLowercase: 'कम से कम एक लोअरकेस अक्षर (a-z)',
  ruleSpecial: 'कम से कम एक विशेष वर्ण',
};

export const resetPasswordArabicData = {
  confirmPasswordText: 'تأكيد كلمة المرور',
  enterNewPasswordText: 'أدخل كلمة المرور الجديدة',
  passwordInputText: 'كلمة المرور',
  passwordInputPlaceholder: 'أدخل كلمة المرور الجديدة',
  confirmPasswordInputText: 'تأكيد كلمة المرور',
  confirmPasswordInputPlaceholder: 'أعد إدخال كلمة المرور الجديدة',
  confirmPasswordButtonText: 'تأكيد كلمة المرور',
  congratulationText: 'تم تغيير كلمة المرور بنجاح',
  congratulationMessageText:
    'تمت إعادة تعيين كلمة المرور الخاصة بك بنجاح. يرجى تسجيل الدخول مرة أخرى بكلمة المرور الجديدة.',
  signInButton: 'العودة إلى تسجيل الدخول',
  privacyPolicyText: 'سياسة الخصوصية',
  termConditionText: 'الشروط والأحكام',
  loginImageText: 'الرسم التوضيحي قيد التطوير',
  passwordLength: 'يجب أن تكون كلمة المرور مكونة من 8 أحرف على الأقل',
  passwordUppercase: 'يجب أن تحتوي كلمة المرور على حرف كبير واحد على الأقل',
  passwordLowercase: 'يجب أن تحتوي كلمة المرور على حرف صغير واحد على الأقل',
  passwordSpecial: 'يجب أن تحتوي كلمة المرور على رمز خاص واحد على الأقل',
  passwordDigit: 'يجب أن تحتوي كلمة المرور على رقم واحد على الأقل',
  passwordsNotMatch: 'كلمات المرور غير متطابقة',
  passwordRequirementsTitle: 'يجب أن تحتوي كلمة المرور على:',
  ruleMinLength: '8 أحرف على الأقل',
  ruleUppercase: 'حرف كبير واحد على الأقل (A-Z)',
  ruleLowercase: 'حرف صغير واحد على الأقل (a-z)',
  ruleSpecial: 'رمز خاص واحد على الأقل',
};
